import { render, staticRenderFns } from "./AoikumoDisabledTooltip.vue?vue&type=template&id=20fe64f0&"
import script from "./AoikumoDisabledTooltip.vue?vue&type=script&lang=js&"
export * from "./AoikumoDisabledTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fe64f0')) {
      api.createRecord('20fe64f0', component.options)
    } else {
      api.reload('20fe64f0', component.options)
    }
    module.hot.accept("./AoikumoDisabledTooltip.vue?vue&type=template&id=20fe64f0&", function () {
      api.rerender('20fe64f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/AoikumoDisabledTooltip.vue"
export default component.exports